import $ from 'jquery';
import slick from 'slick-carousel';

import imgLoad from '../utils/img-load';
import breakpoints from '../utils/breakpoints';

export default {

  init() {
    imgLoad.on('always', () => this.slickInit());
    this.slickInit();
  },

  slickInit() {
    const bp = breakpoints['tablet'];

    const $carousel = $('.marquee-carousel');
    const settings = {
      mobileFirst: true,
      speed: 3000,
      autoplay: true,
      autoplaySpeed: 0,
      infinite: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      variableWidth: true,
      pauseOnHover: true,
      pauseOnFocus: true,
    };

    $carousel.slick(settings);

  },

}
